module.exports = __webpack_public_path__ + "files/1f1310991587ec7f5b77f578fde97c37.png";